import { render, staticRenderFns } from "./IndemnityReqPop.vue?vue&type=template&id=10973808&scoped=true"
import script from "./IndemnityReqPop.vue?vue&type=script&lang=js"
export * from "./IndemnityReqPop.vue?vue&type=script&lang=js"
import style0 from "./IndemnityReqPop.vue?vue&type=style&index=0&id=10973808&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10973808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10973808')) {
      api.createRecord('10973808', component.options)
    } else {
      api.reload('10973808', component.options)
    }
    module.hot.accept("./IndemnityReqPop.vue?vue&type=template&id=10973808&scoped=true", function () {
      api.rerender('10973808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/IndemnityReqPop.vue"
export default component.exports